import {
  GENERATE_REPLY,
  FETCH_CHAT_HISTORY,
  DELETE_CHAT_HISTORY,
} from "../constants/url";
import httpBase from "../utils/http.utils";

export const generateReplyApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(GENERATE_REPLY, data);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const fetchChatHistory = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const requestParams = {
        limit: 15,
        ...params,
      };
      // Send `user_id` as a query parameter
      const apidata = await httpBase().post(FETCH_CHAT_HISTORY, null, {
        params: requestParams,
      });

      const response = [...apidata?.data?.data].reverse();

      successCallback({
        responseData: response,
        responseMeta: apidata?.data?.meta,
      });
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const chatDeleteAPI = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const shouldUseDeletePayload = Boolean(params?.useDeletePayload);
      let response;

      if (shouldUseDeletePayload) {
        response = await httpBase().delete(DELETE_CHAT_HISTORY, {
          data: {
            message_id: Array.isArray(params?.message_id)
              ? params.message_id
              : [],
            user_id: params?.user_id,
            clear_customer_fields: Boolean(params?.clear_customer_fields),
          },
        });
      } else {
        response = await httpBase().post(DELETE_CHAT_HISTORY, null, {
          params: { user_id: params.user_id },
        });
      }

      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};
